import React from 'react';
import './NocLegends.css';
import { Icon } from '../../../globalUtils/globalIcons';

interface NocLegendsProps {
  showLegends: boolean;
}
const NocLegends: React.FC<NocLegendsProps> = ({ showLegends }) => {

  return (
    <div className={`noc-dashboard-legends-container ${!showLegends ? 'hidden' : ''}`}>
      <div className='noc-dashboard-legends-header'>Legends</div>

      <div className='noc-dashboard-legends-info'>
        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-critical-alarm'
          />
          <div>
            Latest Critical Alarm
          </div></div>

        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-major-alarm'
          />
          <div>
            Latest Major Alarm
          </div></div>
        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-minor-alarm'
          />
          Latest Minor Alarm</div>
        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-noactive-alarm'
          />
          No Active Alarm</div>
        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-offline-charger'
          />
          Offline Charger</div>
        <div className='noc-dashboard-legend'>
          <Icon

            iconClassName='noc-dashboard-legend-active-charging-session'
          />
          Active Charging Session</div>
        <div className='noc-dashboard-legend-last'>
          <Icon

            iconClassName='rms__icon custom__noc__map__charging-status-inactive-btn-icon'
          />
          Idle Charger</div>
      </div>
    </div>
  );
};

export default NocLegends;